import { render, staticRenderFns } from "./edit-group-exam-modal.vue?vue&type=template&id=79a72636&scoped=true"
import script from "./edit-group-exam-modal.vue?vue&type=script&lang=ts"
export * from "./edit-group-exam-modal.vue?vue&type=script&lang=ts"
import style0 from "./edit-group-exam-modal.vue?vue&type=style&index=0&id=79a72636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a72636",
  null
  
)

export default component.exports